import {
  Component,
  computed,
  inject,
  input,
  Signal,
  signal,
  WritableSignal,
} from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { BackendService } from '@core/services';
import { BaseComponent } from '@shared/classes';
import { FooterLinkComponent } from '@shared/components/footer-link/footer-link.component';
import { Pages } from '@shared/constants';
import { FooterSecondVariantConfig, MenuItems, NavBar } from '@shared/models';

@Component({
  selector: 'b2c-variant2',
  styleUrl: './variant2.component.scss',
  imports: [FooterLinkComponent, RouterLink, RouterLinkActive],
  templateUrl: './variant2.component.html',
})
export class Variant2Component extends BaseComponent {
  config = input.required<FooterSecondVariantConfig>();

  menuVisible: WritableSignal<boolean> = signal(false);
  navbar: NavBar = this.loyaltyChallengeConfig.components.navbar;

  menuItems: Signal<MenuItems[]> = computed(() => {
    const campaignBisExist =
      this.environment.hasCampaignBis &&
      this.dataService.hasCurrentBisCampaign();

    return this.navbar.items.filter(
      (item: MenuItems) =>
        (item.url === Pages.HELP &&
          this.dataService
            .config()
            .pages.availablePages.includes(Pages.HELP)) ||
        (item.url === Pages.CURRENT && this.dataService.hasCurrentCampaign()) ||
        (item.url === Pages.CURRENT_BIS && campaignBisExist) ||
        (item.url === Pages.HISTORY &&
          this.dataService.hasCompletedCampaigns()) ||
        (item.url === Pages.SOON &&
          (this.dataService.hasFutureCampaign() ||
            this.dataService.hasFutureBisCampaign()))
    );
  });

  protected readonly backendService = inject(BackendService);

  openMenu(): void {
    this.menuVisible.update((value) => !value);
  }
}
